import React from "react";

import UtmParamsContextProvider from "./src/context/utmParams";
import CookieConsentsContextProvider from "./src/context/cookieConsents";
import { initServices } from "./src/services";

const { geoService } = initServices();

const wrapWithProviders = ({ element }) => (
    <CookieConsentsContextProvider geoService={geoService}>
        <UtmParamsContextProvider>{element}</UtmParamsContextProvider>
    </CookieConsentsContextProvider>
);

export default wrapWithProviders;
